export const formatShortDate = date => {
	const options = { month: 'numeric', day: 'numeric', year: '2-digit' };
	const formattedDate = date
		? new Date(date.seconds * 1000).toLocaleDateString('en-US', options)
		: '-';
	return formattedDate;
};